import React, { FC, useEffect, useState } from 'react'
import { round } from 'lodash-es'
import EditIcon from 'components/atoms/Svgs/Edit'
import CheckIcon from 'components/atoms/Icons/Controls/Check'
import ControlledTooltip from 'components/atoms/Tooltip/ControlledTooltip'
import styles from './PercentageVATCalculator.module.scss'
import { $TSFixMe } from 'types/ts-migrate'
import { NumericFormat } from 'react-number-format'

type Props = {
  vatApplied: boolean
  disabled?: boolean
  amount?: number
  onChange: (e: $TSFixMe) => void
}

const PercentageVATCalculator: FC<Props> = ({ vatApplied, disabled, amount = 0, onChange }) => {
  const [state, setState] = useState({
    editExAmount: false,
    value: amount,
    excludingValue: round(amount / 1.15, 2),
  })

  useEffect(() => {
    setState(prev => ({
      ...prev,
      value: amount,
      excludingValue: round(amount / 1.15, 2),
    }))
  }, [amount])

  const formattedAmount = !isNaN(state.excludingValue) ? state.excludingValue : '0.00'

  const handleExAmountChange = (e: $TSFixMe) => {
    const { floatValue } = e
    const including = round(floatValue * 1.15, 2)

    setState(prev => ({ ...prev, excludingValue: floatValue, value: including }))
  }

  return vatApplied ? (
    <span className={styles['sub-text']}>
      <span>
        {state.editExAmount ? (
          <NumericFormat
            className={styles['inline-input']}
            name="percentageField.editExAmount"
            thousandSeparator=" "
            value={state.excludingValue}
            placeholder="0,00"
            onValueChange={handleExAmountChange}
            decimalScale={2}
            fixedDecimalScale
            defaultValue={0}
            allowNegative={false}
          />
        ) : (
          formattedAmount
        )}
        % excluding VAT
      </span>
      {!disabled &&
        (state.editExAmount ? (
          <CheckIcon
            className={styles['edit-button']}
            width={20}
            height={20}
            onClick={() => {
              setState({ ...state, editExAmount: !state.editExAmount })
              onChange(state.value)
            }}
          />
        ) : (
          <ControlledTooltip body="Edit percentage">
            <EditIcon
              className={styles['edit-button']}
              width={20}
              height={20}
              onClick={() => setState({ ...state, editExAmount: !state.editExAmount })}
            />
          </ControlledTooltip>
        ))}
    </span>
  ) : null
}

export default PercentageVATCalculator
